import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { CandidatoService } from '../candidato.service';
import { ArquivoService } from '../../shared/services/arquivo.service';
import { Observable } from 'rxjs/Observable';
import { Util } from '../../shared/util';
import { ConfirmationService } from 'primeng/primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { StatusCandidato } from '../../../models/statusCandidato';
import { AbstractControl, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Usuario } from '../../../models/usuario';
import { Perfis } from '../../../models/perfis';

@Component({
  selector: 'sispac-gerenciar-status-aluno',
  templateUrl: './gerenciar-status-aluno.component.html',
  styleUrls: ['./gerenciar-status-aluno.component.css']
})
export class GerenciarStatusAlunoComponent extends WebPage implements OnInit {
  candidato;
  idCandidato;
  statusCandidatoList;
  form: FormGroup;
  historico;
  usuario: Usuario;
  statusCandidatoAll;

  arquivosToRemove = new FormArray([]);
  uploadUrl: string;

  @ViewChild('cpfConsultado') cpfConsultado: ElementRef;

  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get IdCandidato() { return this.form.get('idCandidato'); }
  get LiberarVaga() { return this.form.get('liberarVaga'); }

  constructor(
    messageService: MessageService,
    private candidatoService: CandidatoService,
    private _router: Router,
    private route: ActivatedRoute,
    private arquivoService: ArquivoService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService
  ) {
    super(messageService);

    this.uploadUrl = this.arquivoService.uploadUrl + 'notaTecnica';
    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );

    this.form = fb.group({
      idCandidato: [null],
      idStatusCandidato: [null, Validators.required],
      liberarVaga: [null],
      justificativa: [null, Validators.required],
      arquivos: new FormArray([]),
      idStatusCandidatoAntes: [null],
      idUsuario: [null],
      nomeUsuario: [null]
    });

  }

  ngOnInit() {
    this.usuario = JSON.parse(localStorage.getItem('usuarioGestao'));

    this.candidatoService
      .getStatusCandidatoPodemSerAlterados()
      .finally(() => (this.isLoading = false))
      .subscribe(
        statusCandidatoList => {
          this.statusCandidatoList = statusCandidatoList

        },
        error => this.gerenciaErro(error)
      );

      this.candidatoService
        .getFull(this.idCandidato)
        .finally(() => (this.isLoading = false))
        .subscribe(
          candidato => {
            this.candidato = candidato;
            if (this.candidato != null) {
              this.form.controls['idCandidato'].setValue(this.candidato.idCandidato);
              this.form.controls['idStatusCandidatoAntes'].setValue(this.candidato.idStatusCandidato);
              this.form.controls['idUsuario'].setValue(this.usuario.IdUsuario);
              this.form.controls['nomeUsuario'].setValue(this.usuario.Nome);
            }

            if(this.usuario.Perfil == Perfis.AdministrativoDex){
              this.candidatoService
                .getHistoricoCandidato(this.idCandidato)
                .finally(() => (this.isLoading = false))
                .subscribe(
                  (historico) => {
                    this.historico = historico.filter((hist) => {
                      if(hist.dataRegistro !== null) return hist});
                  }
              )
            }
          },
          error => this.gerenciaErro(error)
      );

      this.candidatoService
      .getStatusCandidato()
      .finally(() => (this.isLoading = false))
      .subscribe(
        statusCandidatoAll => {
          this.statusCandidatoAll = statusCandidatoAll;
          if (this.isAdmin()) this.statusCandidatoList = statusCandidatoAll;
        },
        error => this.gerenciaErro(error)
      );
  }

  // Arquivos
  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean) {
    this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeArquivo: nomeArquivo,
      isOld: isOld
    });
    this.arquivos.push(arquivoFormGroup);
  }

  removeArquivo(arquivo: AbstractControl) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);
  }



  removeArquivosDoBanco(arquivos: AbstractControl[]) {
    arquivos.forEach(arquivo =>
      this.arquivoService.removeArquivo(arquivo.value.idArquivo)
        .subscribe(() => {

        })
    );
  }



  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.removeArquivosDoBanco(this.arquivos.controls);
        this.removeArquivosDoBanco(this.arquivosToRemove.controls);
        this._router.navigate(['/admin']);
      }
    });
  }

  submit() {
    // if (this.form.value.arquivos.length === 0) {
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Atenção',
    //     detail: 'A nota técnica é obrigatória'
    //   });
    //   return;
    // }
    if (!this.form.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Campo obrigatório não preenchido!'
      });
      return;
    }


    /*if (this.form.value.idStatusCandidato.toUpperCase() === !StatusCandidato.DesclassificadoPorOutroMotivo) {
      this.LiberarVaga.setValue(null);
    }*/

    this.confirmationService.confirm({
      message: 'Deseja mesmo alterar o status deste aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          this.candidatoService.alterarStatusCandidato(this.form.value)
          .subscribe(candidato => {
            this.messageService.add({
              severity: 'success',
              summary: 'Atenção',
              detail: 'Status Atualizado com sucesso!'
            });
            this._router.navigate(['/gerenciar-etapas']);
          },
          error => this.gerenciaErro(error));
      }
    });
  }

  getStatus(idStatus:string){
    if(idStatus == null || idStatus == undefined) return '-';
    if(this.statusCandidatoAll != undefined){
      let status = (this.statusCandidatoAll.filter((s) => { if(s.idStatusCandidato === idStatus) return s;}));
      return status[0].descricao;
    }
    return '-';
  }
  isAdmin(){
    return (this.usuario.Perfil === Perfis.AdministradorSistema || this.usuario.Perfil === Perfis.AdministrativoDex)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/candidato/gerenciar-status-aluno/gerenciar-status-aluno.component.ts